angular.module('impactx.company').controller('ClientCompanyDataCtrl', [
    '$scope',
    'dataGen',
    'selectedListItems',
    'BackService',
    'ToastService',
    'WarningService',
    'TranslationService',
    '$routeParams',
    'ToolbarService',
    '$config',
    'PartialDialogsService',
    'TinyMceHelperService',
    ClientCompanyData]);

function ClientCompanyData($scope, dataGen, selectedListItems, BackService, ToastService, WarningService, TranslationService,
                           $routeParams, ToolbarService, $config, PartialDialogsService, TinyMceHelperService) {
    var ctrl = this;
    var companyId = $routeParams.id;
    var createNewsMessageObj = true;

    $scope.configData = {};

    dataGen.getData($scope, {id: companyId}, "/company/clientcompany/view").then(function () {
        $scope.readOnly = !$scope.data.clientCompany.isClientCompany.value;
        var configData = configData;
        if ($scope.data.clientCompany.wasClient) {
            configData = JSON.parse(JSON.stringify($scope.data.clientCompany.clientConfig));
        }
        else {
            configData = JSON.parse(JSON.stringify($scope.data.clientCompany.readOnlyConfig));
        }
        if(createNewsMessageObj && typeof configData.newsMessage === 'undefined') {
            configData.newsMessage = {};
        }
        $scope.configData = configData;
        defineButtons();
    });

    this.toggleIsClient = function (event) {
        $scope.readOnly = !$scope.readOnly;
        var clientComData = $scope.data.clientCompany;
        var configData;
        if ($scope.readOnly) {
            configData = JSON.parse(JSON.stringify(clientComData.readOnlyConfig));
        }
        else if (clientComData.wasClient && !clientComData.hasSuperClient) {
            configData = JSON.parse(JSON.stringify(clientComData.clientConfig));
        }
        if(configData) {
            if(createNewsMessageObj && typeof configData.newsMessage === 'undefined') {
                configData.newsMessage = {};
            }
            $scope.configData = configData;
        }
    };

    this.save = function (event) {
        if ($scope.data.clientCompany.hasAATRelations && !$scope.data.clientCompany.isClientCompany.value) {
            WarningService.showWarningDialog(ctrl.saveInternal, event, TranslationService.get("warning"), TranslationService.get("forward"),
                TranslationService.get("abort"), [$scope.trns.aatDeletionToo]);
        }
        else {
            return ctrl.saveInternal(event);
        }
    };

    this.saveInternal = function ($event) {
        if ($scope.data.clientCompany.isClientCompany.value) { // prepare data for save
            $scope.data.clientCompany.clientConfig = $scope.configData;
        }
        var dataObj = {
            clientCompany: $scope.data.clientCompany
        };
        return dataGen.postAsForm({}, dataObj, "/company/clientcompany/save").then(function () {
            ToastService.openStandardToast($scope.trns.saveSuccess);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.COMPANY, companyId, 'clientcompanydata');
        });
    };

    this.requireLanguageHeader = function (docNotes, lang) {
        if (docNotes && lang) {
            var inUse = impactX.isDefined(docNotes, 'useHeader.value');
            if (inUse) {
                return $scope.data.clientCompany.requiredLanguage === lang
            }
        }
        return false;
    };

    this.requireLanguageFooter = function (docNotes, lang) {
        if (docNotes && lang) {
            var inUse = impactX.isDefined(docNotes, 'useFooter.value');
            if (inUse) {
                return $scope.data.clientCompany.requiredLanguage === lang
            }
        }
        return false;
    };

    this.clearSelected = function (popup) {
        if (popup && popup.selected && popup.selected.id === 0) {
            delete popup.selected;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    $scope.tinymceOptions = TinyMceHelperService.getConfigurationWithUpload($config.tinymceOptions);
}